export default "__VITE_ASSET__BEKreWN7__"